import DefaultLayout from '##/Default';
import View from './View';
import Evaluations from './Evaluations';


const routes = [
    {
        path: '/employees/:employee_id/evals/:eval_id',
        exact: true,
        layout: DefaultLayout,
        component: View,
        auth: true,
        title: 'View Eval'
    },
    {
        path: '/evaluations',
        exact: true,
        layout: DefaultLayout,
        component: Evaluations,
        auth: true,
        title: 'Employee Evaluations'
    }
];

export default routes;
